<template>
  <div class="au-help">
    <h2>auメール（@au.com、@ezweb.ne.jp）をご利用のお客様へ</h2>

    <p>弊社からのメールが届かない事象が多く発生しております。</p>

    <p>
      auの初期設定では、PCからのメールが受信できない場合があるため、お手数ですが下記の方法で受信設定をお願いいたします。
    </p>

    <div class="setting-section">
      <h3>✅ 設定を行える方</h3>

      <div class="setting-item">
        <h4>①「受信リスト設定」での許可（必ず受信）</h4>
        <p>受信リストに【@sukisuki.live】を追加し、「必ず受信」にチェックを入れてください。</p>
        <p>詳しい手順はau公式サイトにてご確認いただけます。</p>
        <p>
          →
          <a
            href="https://www.au.com/support/service/mobile/trouble/mail/email/filter/detail/domain/"
            target="_blank"
            >受信リスト設定（au公式）</a
          >
        </p>
      </div>

      <div class="setting-item">
        <h4>② 受信リスト設定をしても届かない場合</h4>
        <p>
          「なりすまし規制」のレベルを変更し、「指定受信リスト設定（なりすまし・転送メール許可）」にも【@sukisuki.live】を登録してください。
        </p>
        <p>こちらもau公式サイトの手順をご参照ください。</p>
        <p>
          →
          <a
            href="https://www.au.com/support/service/mobile/trouble/mail/email/filter/detail/forgery/"
            target="_blank"
            >なりすまし規制設定（au公式）</a
          >
        </p>
      </div>
    </div>

    <div class="contact-section">
      <h3>📞 設定が難しい場合</h3>
      <p>
        設定方法がわからない方は、<a href="inquiry" target="_blank">お問合わせ</a
        >よりメッセージ欄に<strong>携帯電話番号</strong>と<strong>ご希望の連絡時間</strong>をご記入ください。
      </p>
      <p>担当者よりお電話にてご案内いたします。</p>
    </div>
  </div>
</template>

<style scoped>
.au-help {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.6;
}

.au-help h2 {
  color: #333;
  margin-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.au-help h3 {
  color: #555;
  margin: 30px 0 15px 0;
  font-size: 1.2em;
}

.au-help h4 {
  color: #666;
  margin: 20px 0 10px 0;
  font-size: 1.1em;
}

.setting-section {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.setting-item {
  margin-bottom: 25px;
}

.setting-item:last-child {
  margin-bottom: 0;
}

.contact-section {
  background-color: #e8f4fd;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.au-help a {
  color: #1976d2;
  text-decoration: none;
}

.au-help a:hover {
  text-decoration: underline;
}

.au-help p {
  margin: 10px 0;
}

.au-help strong {
  color: #d32f2f;
  font-weight: bold;
}
</style>
